// src/pages/income/env/disinfection/IncomeEnvDisinfectionDraftPreviewWindow.jsx
// ✅ 환경/소독 미리보기 새 창 라우트 element — 얇은 래퍼.
import React from "react";
import IncomeDraftPreviewWindow from "../../_shared/IncomeDraftPreviewWindow";
import incomeEnvDisinfectionDraftConfig from "./incomeEnvDisinfectionDraftConfig";

export default function IncomeEnvDisinfectionDraftPreviewWindow() {
  return <IncomeDraftPreviewWindow config={incomeEnvDisinfectionDraftConfig} />;
}
